module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fb-Ga-Hc-Ia.1a17a4cb.png";